import { useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    IconButton
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { StyledTextField } from "./Containers";
import _ from "lodash";

export default function AddUrl({ label = 'Add link', open, onClose, onAdd }) {
    const [url, setUrl] = useState('');

    const handleAdd = () => {
        if (!url) return;
        onAdd(url);
        setUrl('');
        onClose();
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="xs"
            fullWidth
            PaperProps={{ sx: { borderRadius: 3 } }}
        >
            <DialogTitle sx={{ pb: 1 }}>
                {label}
                <IconButton
                    onClick={onClose}
                    sx={{ position: "absolute", right: 8, top: 8 }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent>
                <StyledTextField width="36ch" value={url} valueHandler={setUrl} multiline />
            </DialogContent>

            <DialogActions sx={{ px: 3, pb: 3 }}>
                <Button onClick={onClose} color="inherit">
                    Cancel
                </Button>
                <Button
                    variant="contained"
                    onClick={handleAdd}
                    disabled={_.isEmpty(url)}
                >
                    Add
                </Button>
            </DialogActions>
        </Dialog>
    );
}
